import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactModal from "react-modal";

import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from "constants/common";

import { getDashboardData } from "store/dashboard/actions";

import { getCurrentUser } from "store/auth/actions";
import { AppDispatch } from "store/reducers";
import { getMeta } from "store/meta/actions";
import { metaSelector } from "store/meta/selectors";
import { userSelector } from "store/auth/selectors";

import { SessionProviderContainerProps } from "./SessionProvider.types";

import SessionProvider from "./SessionProvider";

const SessionProviderContainer = (props: SessionProviderContainerProps) => {
  const meta = useSelector(metaSelector);
  const user = useSelector(userSelector);

  const dispatch = useDispatch<AppDispatch>();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const appElement =
      document.getElementById("klarvest") ||
      document.querySelector("[id*='widget']") ||
      document.body;

    ReactModal.setAppElement(appElement);

    dispatch(getMeta());

    if (
      navigator !== undefined &&
      /iPad|iPhone|iPod/.test(navigator?.userAgent)
    ) {
      document?.documentElement?.setAttribute("data-ios", "true");
    }
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem(AUTH_TOKEN_KEY);

    if (!authToken) {
      setLoading(false);

      return;
    }

    const _checkAuthUser = async () => {
      try {
        await dispatch(getCurrentUser()).unwrap();
      } catch (error) {
        console.warn(`Check Auth User: ${JSON.stringify(error)}`);

        localStorage.removeItem(AUTH_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);

        return;
      }

      setLoading(false);
    };

    _checkAuthUser();
  }, []);

  useEffect(() => {
    if (user?.id) {
      dispatch(getDashboardData() as any);
    }
  }, [user?.id]);

  return (
    <>
      <SessionProvider
        {...props}
        loading={loading}
        courses={meta?.courses || []}
      />
    </>
  );
};

export default SessionProviderContainer;
